module.exports = __webpack_public_path__ + "01_glasses_brown.30a1cad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/01_glasses_brown.png
// module id = pK00
// module chunks = 0